import React from "react";
import CurrencyFormat from 'react-currency-format';
import PropTypes from 'prop-types';

const EngageCurrency = ({style, amount}) => {
    return <CurrencyFormat
        style={{...style}}
        value={amount}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        decimalScale={2}
        fixedDecimalScale={true}
    />
};

EngageCurrency.propTypes = {
    amount: PropTypes.number,
    style: PropTypes.object,
}

export default EngageCurrency;
